<page-content>
    <header-elitment header>
    </header-elitment>
    <side-menu left-menu>
    </side-menu>
    <ng-container *ngIf="!is401">
        <div>
            salut
        </div>
    </ng-container>
    <error-401 *ngIf="is401"></error-401>
    <footer-elitment footer></footer-elitment>
</page-content>
